var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0.014 11.52 12.052",
    width: 11.52,
    height: 12.052,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.026447, 0, 0, 0.027734, 0, 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M417.485,40.549l0.002-0.002l-0.041-0.038c-0.012-0.016-0.025-0.029-0.041-0.039 c-53.388-53.302-140.181-53.275-193.531,0.077l-96.537,96.538l0,0l-87.303,87.301c-53.352,53.352-53.378,140.145-0.077,193.53 c0.014,0.014,0.024,0.027,0.039,0.043l0.038,0.039h0.004c0,0,32.317,38.459,70.82-0.041c38.501-38.502,60.923-60.922,60.923-60.922 l-6.117-110.48l80.378-80.38l95.7,20.898c0,0,34.891-34.889,75.703-75.701C458.257,70.557,417.485,40.549,417.485,40.549z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOff);
export default __webpack_public_path__ + "static/media/phone_off.3a5779fc897e3f69b61eec56b6fe160b.svg";
export { ForwardRef as ReactComponent };